/* eslint-disable react/prop-types */
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import {
  Box,
  TableCell,
  TableRow,
  Divider,
  useMediaQuery,
} from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import AutoCompleteDropdown from "../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import Button from "../../../components/common/Button";
import InputField from "../../../components/common/new/InputField/InputField";
import OrganizationStructure from "../../../components/common/OrganizationStructure/OrganizationStructure";
import Toast from "../../../components/common/Toast";
import {
  MEMBER_TRANSFER_REQUEST_FIELDS,
  NEW_ENTRY_FIELDS,
  ORGANIZATION_STRUCTURE_FIELDS,
} from "../../../contants/formFields";
import { MEMBER_TRANSFER_TO } from "../../../contants/table/memberTransfer";
import MembersApi from "../../../services/api/member";
import IntroductionFormApi from "../../../services/api/introductionForm";
import tableStyle from "../../../theme/styles/table";
import { getOptions, handleTransferValidation } from "../../../utils";
import SwitchButton from "../../../components/common/SwitchButton/SwitchButton";
import Loader from "../../../components/common/Loader/Loader";
import CustomTable from "../../../components/common/new/Table/Table";
import Styles from "./MemberTransferTo.styles";
import { debounce, isEmptyObj } from "../../../utils/helper";
import { ROUTES } from "../../../utils/constants";

const getRows = (selectedMember) => (
  <TableRow style={tableStyle.tableRow}>
    <TableCell>
      {" "}
      {selectedMember.fullName} <br />
      <LocationOnIcon style={tableStyle.locationIcon} />{" "}
      {selectedMember.addressLine1}
    </TableCell>
    <TableCell>
      {" "}
      <PhoneIcon style={tableStyle.icon} /> {selectedMember.mobileNumber || "-"}{" "}
      <br />
      <EmailIcon style={tableStyle.icon} /> {selectedMember.emailId || "-"}
    </TableCell>
    <TableCell>{selectedMember.districtName || "-"} </TableCell>
    <TableCell>{selectedMember.areaName || "-"} </TableCell>
    <TableCell>{selectedMember.zoneName || "-"} </TableCell>
    <TableCell>{selectedMember.regionName || "-"} </TableCell>
    <TableCell>{selectedMember.chapterName || "-"} </TableCell>
    <TableCell>{selectedMember.districtName || "-"} </TableCell>
  </TableRow>
);

function MemberTransferBasicFields({
  setFieldValue,
  handleChange,
  values,
  selectedMember,
  errors,
}) {
  const [divisions, setDivisions] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [showAddress, setShowAddress] = useState(false);
  const [pincode, setPinCode] = useState(false);

  const getDivisions = async () => {
    const response = await IntroductionFormApi.getDivisions();
    setDivisions(response.data);
  };

  const getStates = async () => {
    const response = await IntroductionFormApi.getStates();
    setStates(response.data);
    if (response?.data) {
      const filteredState = response.data.find((s) => {
        return s.stateId === Number(selectedMember.state);
      });
      if (filteredState) {
        setFieldValue(
          MEMBER_TRANSFER_REQUEST_FIELDS.STATE,
          filteredState.stateId
        );
        setCities(filteredState.cities);
        const filteredCity = filteredState.cities.find((c) => {
          return c.cityId === Number(selectedMember.city);
        });
        if (filteredCity) {
          setFieldValue(
            MEMBER_TRANSFER_REQUEST_FIELDS.CITY,
            filteredCity.cityId
          );
        }
      }
    }
  };

  useEffect(() => {
    getStates();
    getDivisions();
  }, []);

  return (
    <div style={Styles.gridContainer}>
      <div style={Styles.prevText}>Same as Previous Address</div>
      <div style={Styles.inputContainer}>
        <SwitchButton
          value={showAddress}
          handleChange={(e) => {
            setShowAddress(e.target.checked);
            setPinCode(e.target.checked);
            setFieldValue(
              MEMBER_TRANSFER_REQUEST_FIELDS.ADDRESS,
              e.target.checked ? selectedMember.addressLine1 : ""
            );

            // ** this feature has a bug same in Friend transfer form **
            // ** BUG: initialValues of city and state are not empty they should be same as addressField,
            // but when we toggle Yes and then toggle No back it works fine **

            setFieldValue(
              [MEMBER_TRANSFER_REQUEST_FIELDS.STATE],
              e.target.checked ? Number(selectedMember.state) : ""
            );
            setFieldValue(
              [MEMBER_TRANSFER_REQUEST_FIELDS.CITY],
              e.target.checked ? Number(selectedMember.city) : ""
            );
            // setFieldValue(
            //   MEMBER_TRANSFER_REQUEST_FIELDS.ADDRESS_LINE_2,
            //   e.target.checked ? selectedMember.addressLine2 : ""
            // );
            setFieldValue(
              MEMBER_TRANSFER_REQUEST_FIELDS.PINCODE,
              e.target.checked ? selectedMember.pincode : ""
            );
          }}
        />
      </div>
      <div style={Styles.name}>
        <InputField
          required
          label="Member's Name"
          name={MEMBER_TRANSFER_REQUEST_FIELDS.MEMBER_NAME}
          onChange={handleChange}
          containerStyle={Styles.inputContainer}
          value={values[MEMBER_TRANSFER_REQUEST_FIELDS.MEMBER_NAME]}
          disabled={values[MEMBER_TRANSFER_REQUEST_FIELDS.MEMBER_NAME]}
        />
      </div>
      <div>
        <InputField
          required
          label="New Address"
          name={MEMBER_TRANSFER_REQUEST_FIELDS.ADDRESS}
          onChange={handleChange}
          containerStyle={Styles.inputContainer}
          value={values[MEMBER_TRANSFER_REQUEST_FIELDS.ADDRESS]}
          disabled={showAddress}
        />
      </div>
      <div>
        <InputField
          label="Pincode"
          containerStyle={Styles.inputContainer}
          name={MEMBER_TRANSFER_REQUEST_FIELDS.PINCODE}
          value={values[MEMBER_TRANSFER_REQUEST_FIELDS.PINCODE]}
          onChange={handleChange}
          inputProps={{ maxlength: 6 }}
          disabled={pincode}
        />
      </div>
      {/* <div>
        <InputField
          label="New Address Line 2"
          name={MEMBER_TRANSFER_REQUEST_FIELDS.ADDRESS_LINE_2}
          onChange={handleChange}
          containerStyle={Styles.inputContainer}
          value={values[MEMBER_TRANSFER_REQUEST_FIELDS.ADDRESS_LINE_2]}
          disabled={showAddress}
        />
      </div> */}
      <div>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.stateName}
          label="State"
          name={MEMBER_TRANSFER_REQUEST_FIELDS.STATE}
          options={getOptions(states, "stateId")}
          error={errors[MEMBER_TRANSFER_REQUEST_FIELDS.STATE]}
          value={Number(values[MEMBER_TRANSFER_REQUEST_FIELDS.STATE])}
          disabled={showAddress}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(MEMBER_TRANSFER_REQUEST_FIELDS.STATE, "");
              setCities([]);
            } else {
              setFieldValue(
                MEMBER_TRANSFER_REQUEST_FIELDS.STATE,
                selectedValue.value
              );
              setCities(selectedValue.cities);
            }
            setFieldValue(MEMBER_TRANSFER_REQUEST_FIELDS.CITY, "");
          }}
        />
      </div>
      <div>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.cityName}
          label="City"
          name={MEMBER_TRANSFER_REQUEST_FIELDS.CITY}
          options={getOptions(cities, "cityId")}
          error={errors[MEMBER_TRANSFER_REQUEST_FIELDS.CITY]}
          value={Number(values[MEMBER_TRANSFER_REQUEST_FIELDS.CITY])}
          disabled={
            !values[MEMBER_TRANSFER_REQUEST_FIELDS.STATE] || showAddress
          }
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(MEMBER_TRANSFER_REQUEST_FIELDS.CITY, "");
            } else {
              setFieldValue(
                MEMBER_TRANSFER_REQUEST_FIELDS.CITY,
                selectedValue.value
              );
            }
          }}
        />
      </div>
      <div>
        <InputField
          required
          label="Contact Number"
          containerStyle={Styles.inputContainer}
          name={MEMBER_TRANSFER_REQUEST_FIELDS.CONTACT_NUMBER}
          value={values[MEMBER_TRANSFER_REQUEST_FIELDS.CONTACT_NUMBER]}
          onChange={handleChange}
          inputProps={{
            maxLength: 10,
          }}

          // disabled={values[MEMBER_TRANSFER_REQUEST_FIELDS.CONTACT_NUMBER]}
        />
      </div>
      <div>
        <InputField
          label="Email Address"
          containerStyle={Styles.inputContainer}
          name={MEMBER_TRANSFER_REQUEST_FIELDS.EMAIL_ADDRESS}
          onChange={handleChange}
          value={values[MEMBER_TRANSFER_REQUEST_FIELDS.EMAIL_ADDRESS]}
        />
      </div>
      <div>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          label="Division"
          name={MEMBER_TRANSFER_REQUEST_FIELDS.DIVISION}
          options={getOptions(divisions, "divisionId")}
          error={errors[MEMBER_TRANSFER_REQUEST_FIELDS.DIVISION]}
          value={values[MEMBER_TRANSFER_REQUEST_FIELDS.DIVISION]}
          disabled={values[MEMBER_TRANSFER_REQUEST_FIELDS.DIVISION]}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(MEMBER_TRANSFER_REQUEST_FIELDS.DIVISION, "");
              setSubDivisions([]);
            } else {
              setFieldValue(
                MEMBER_TRANSFER_REQUEST_FIELDS.DIVISION,
                selectedValue.value
              );
              setSubDivisions(selectedValue.subDivisions);
            }
            setFieldValue(MEMBER_TRANSFER_REQUEST_FIELDS.SUB_DIVISION, "");
          }}
        />
      </div>
      <div>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          label="Sub Division"
          name={MEMBER_TRANSFER_REQUEST_FIELDS.SUB_DIVISION}
          options={getOptions(subDivisions, "divisionId")}
          error={errors[MEMBER_TRANSFER_REQUEST_FIELDS.SUB_DIVISION]}
          value={values[MEMBER_TRANSFER_REQUEST_FIELDS.SUB_DIVISION]}
          disabled={values[MEMBER_TRANSFER_REQUEST_FIELDS.DIVISION]}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(MEMBER_TRANSFER_REQUEST_FIELDS.SUB_DIVISION, "");
            } else {
              setFieldValue(
                MEMBER_TRANSFER_REQUEST_FIELDS.SUB_DIVISION,
                selectedValue.value
              );
            }
          }}
        />
      </div>
      {values[MEMBER_TRANSFER_REQUEST_FIELDS.DIVISION] === 52 ||
      values[MEMBER_TRANSFER_REQUEST_FIELDS.DIVISION] === 53 ? (
        <>
          <div style={Styles.gridItem}>
            <InputField
              required
              label="Parent's Contact Number"
              name={MEMBER_TRANSFER_REQUEST_FIELDS.PARENT_CONTACT_NUMBER}
              value={
                values[MEMBER_TRANSFER_REQUEST_FIELDS.PARENT_CONTACT_NUMBER]
              }
              onChange={handleChange}
              error={
                errors[MEMBER_TRANSFER_REQUEST_FIELDS.PARENT_CONTACT_NUMBER]
              }
              inputProps={{
                maxLength: 10,
              }}
            />
          </div>
          <div style={Styles.gridItem}>
            <InputField
              label="Parent's Email Address"
              name={MEMBER_TRANSFER_REQUEST_FIELDS.PARENT_EMAIL_ADDRESS}
              value={
                values[MEMBER_TRANSFER_REQUEST_FIELDS.PARENT_EMAIL_ADDRESS]
              }
              error={
                errors[MEMBER_TRANSFER_REQUEST_FIELDS.PARENT_EMAIL_ADDRESS]
              }
              onChange={handleChange}
            />
          </div>
        </>
      ) : null}
      <div>
        <InputField
          required
          label="Introducer's Name"
          type="text"
          name={MEMBER_TRANSFER_REQUEST_FIELDS.INTRODUCED_BY_NAME}
          value={values[MEMBER_TRANSFER_REQUEST_FIELDS.INTRODUCED_BY_NAME]}
          onChange={handleChange}
        />
      </div>
      <div>
        <InputField
          required
          label="Introducer's Contact Number"
          type="text"
          name={MEMBER_TRANSFER_REQUEST_FIELDS.INTRODUCED_BY_MOBILE_NUMBER}
          value={
            values[MEMBER_TRANSFER_REQUEST_FIELDS.INTRODUCED_BY_MOBILE_NUMBER]
          }
          onChange={handleChange}
          inputProps={{
            maxLength: 10,
          }}
        />
      </div>
      <div>
        <InputField
          label="Introducer's Email Address"
          type="text"
          name={MEMBER_TRANSFER_REQUEST_FIELDS.INTRODUCED_BY_EMAIL}
          value={values[MEMBER_TRANSFER_REQUEST_FIELDS.INTRODUCED_BY_EMAIL]}
          onChange={handleChange}
        />
      </div>
      <div>
        <InputField
          type="text"
          key="remark"
          name="remark"
          label="Remark"
          value={values.remark}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

function MemberTransferTo() {
  // const userProfile = useSelector((state) => state.auth.userProfile);
  const [showToast, setShowToast] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  const selectedMember = useSelector(
    (state) => state.view_members.selectedMemberForTransfer
  );

  const isMobile = useMediaQuery("(max-width: 768px)");

  const postData = async (values) => {
    try {
      const data = {
        ...values,
        remark: {
          data: { message: values.remark, event: "success" },
        },
      };
      const response = await MembersApi.transferMember({
        data,
        memberId: selectedMember.memberId,
      });
      setTimeout(() => {
        setSuccess(true);
        navigate(`/${ROUTES.MEMBER_TRANSFER.path}`);
      }, 2000);
      if (response) {
        // const remarkResponse = await MembersApi.transferMember({
        //   data: {
        //     message: remark,
        //     event: "success",
        //   },
        // });

        // console.log("Remark Response:", remarkResponse);
        setSuccess(true);
        setShowToast({
          message: "Form submitted successfully",
          severity: "success",
        });
      }
    } catch (err) {
      setShowToast({ message: err.message, severity: "error" });
      Sentry.captureException(err);
    }
  };

  if (isEmptyObj(selectedMember)) {
    return <Loader />;
  }

  return (
    <Box>
      <Box mb={4}>
        {!isMobile && (
          <CustomTable
            columns={MEMBER_TRANSFER_TO}
            rows={getRows(selectedMember)}
          />
        )}
      </Box>
      <Formik
        enableReinitialize
        initialValues={{
          nationalityId: selectedMember?.nationalityId || 1,
          ...selectedMember,
          [MEMBER_TRANSFER_REQUEST_FIELDS.MEMBER_NAME]: selectedMember.fullName,
          [MEMBER_TRANSFER_REQUEST_FIELDS.FRIEND_ID]: selectedMember.friendId,
          [MEMBER_TRANSFER_REQUEST_FIELDS.ADDRESS]: "",
          [MEMBER_TRANSFER_REQUEST_FIELDS.ADDRESS_LINE_1]: "",
          // [MEMBER_TRANSFER_REQUEST_FIELDS.ADDRESS_LINE_2]: "",
          [MEMBER_TRANSFER_REQUEST_FIELDS.STATE]: "",
          [MEMBER_TRANSFER_REQUEST_FIELDS.CITY]: "",
          [MEMBER_TRANSFER_REQUEST_FIELDS.PINCODE]: "",
          [MEMBER_TRANSFER_REQUEST_FIELDS.DATE_OF_JOINING]:
            selectedMember.createdAt,
          [MEMBER_TRANSFER_REQUEST_FIELDS.CONTACT_NUMBER]:
            selectedMember.mobileNumber,
          [MEMBER_TRANSFER_REQUEST_FIELDS.EMAIL_ADDRESS]:
            selectedMember.emailId,
          [MEMBER_TRANSFER_REQUEST_FIELDS.DIVISION]: selectedMember.divisionId,
          [MEMBER_TRANSFER_REQUEST_FIELDS.SUB_DIVISION]:
            selectedMember.subdivisionId,
          [ORGANIZATION_STRUCTURE_FIELDS.AREA]: "",
          [ORGANIZATION_STRUCTURE_FIELDS.ZONE]: "",
          [ORGANIZATION_STRUCTURE_FIELDS.REGION]: "",
          [ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]: "",
          [ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]: "",
          [MEMBER_TRANSFER_REQUEST_FIELDS.INTRODUCED_BY_NAME]:
            selectedMember?.introducerName,
          [MEMBER_TRANSFER_REQUEST_FIELDS.INTRODUCED_BY_MOBILE_NUMBER]:
            selectedMember?.introducerMobileNumber,
          [MEMBER_TRANSFER_REQUEST_FIELDS.INTRODUCED_BY_EMAIL]:
            selectedMember?.introducerEmail,
        }}
        onSubmit={debounce((values) => {
          const result = handleTransferValidation(NEW_ENTRY_FIELDS, values, [
            NEW_ENTRY_FIELDS.ADDRESS_LINE_1,
          ]);
          if (result && Object.keys(result).length) {
            setShowToast(result);
            return;
          }
          const { remark } = values;
          postData(values, remark);
        })}
      >
        {({
          values,
          errors,
          handleChange,
          handleSubmit,
          setFieldValue,
          /* and other goodies */
        }) => (
          <>
            <Box
              style={{
                ...Styles.main,
                ...(isMobile && {
                  flexDirection: "column",
                  padding: "0px 24px",
                }),
              }}
            >
              <Box style={Styles.leftContainer}>
                <MemberTransferBasicFields
                  values={values}
                  handleChange={handleChange}
                  errors={errors}
                  setFieldValue={setFieldValue}
                  selectedMember={selectedMember}
                />
              </Box>
              <Box
                style={{
                  ...Styles.rightContainer,
                  width: isMobile ? "100%" : "",
                }}
              >
                <OrganizationStructure
                  values={values}
                  handleChange={handleChange}
                  errors={errors}
                  setFieldValue={setFieldValue}
                  isLoading={false}
                  showZoneLocator
                />
              </Box>
            </Box>
            <Divider
              sx={{
                display: "flex",
                width: "100%",
                margin: "2rem 0",
              }}
            />
            <Box
              sx={
                isMobile && {
                  minHeight: isMobile ? "190px" : "",
                  padding: "0px 24px",
                }
              }
            >
              <Button
                type="submit"
                isLoading={isLoading}
                label="Submit"
                onClick={handleSubmit}
              />
            </Box>
          </>
        )}
      </Formik>
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
    </Box>
  );
}

export default MemberTransferTo;
